import { ListHeaderCell, ListHeaderCellType } from 'views/components/atoms/listCell';
import { ListHeaderType } from 'views/components/molecules/listHeader';

export type OrderStatusData = {
  // 初期申込ID
  initialApplicationId: string;
  accountNumber: string;
  code: string;
  name: string;
  // 申込ステータス
  status: string;
};

export type OrderStatusResponse = {
  total: number;
  orderStatusList: OrderStatusData[];
};

export type GetOrderStatusRequestParam = {
  page: number;
  limit: number;
  accountNumber: string;
  name: string;
  status: string;
};
export type OrderStatusDetailResponse = {
  //     初期申込ID: string
  // 口座番号: string
  // 銘柄コード: string
  // 銘柄名: string
  // 申込ステータス
  // 最終申込日時: string(yyyy/MM/dd HH:mm:ss)
  // 申込合計数量: decimal
  // 購入数量: decimal
  // 購入金額: decimal
  // 申込履歴: list
  // 申込ID: string
  // SFs管理ID: string
  // 申込日時: string(yyyy/MM/dd HH:mm:ss)
  // 申込数量: decimal
  // 申込金額: decimal
  // 適合性チェック回避フラグ: bool

  initialApplicationId: string;
  accountNumber: string;
  code: string;
  name: string;
  status: string;
  lastApplicationDate: string;
  totalApplicationQuantity: number;
  purchaseQuantity: number;
  purchaseAmount: number;
  applicationHistory: ApplicationHistory[];
};

export type ApplicationHistory = {
  applicationId: string;
  sfsManagementId: string;
  applicationDate: string;
  applicationQuantity: number;
  applicationAmount: number;
  suitabilityCheckAvoidanceFlag: boolean;
};

export const headerShowList: ListHeaderType[] = [
  {
    type: ListHeaderCellType.textCell,
    label: '分類',
  },
  {
    type: ListHeaderCellType.sentenceCell,
    label: '銘柄名',
  },
  {
    type: ListHeaderCellType.applyQtyCell,
    label: '申込口数',
  },
  {
    type: ListHeaderCellType.quantityCell,
    label: '配分口数',
  },
  {
    type: ListHeaderCellType.amountCell,
    label: '配分金額',
  },
  {
    type: ListHeaderCellType.dateCell,
    label: '最終申込日',
  },
  {
    type: ListHeaderCellType.refundCell,
    label: '未配分資金',
  },
];
